<template>
  <div
    v-if="initialized"
    class="flex h-full w-full"
    :class="{ 'flex-col': mq.isMobile }"
  >
    <NavbarDesktopSupervisor />
    <main
      id="page"
      class="h-full w-full overflow-y-auto p-5"
    >
      <router-view />
    </main>
  </div>
</template>

<script setup>
import NavbarDesktopSupervisor from '@/app/_supervisors/components/navbar/TheNavbarDesktopSupervisor.vue';
import { onBeforeMount } from 'vue';
import useProfile from '@/app/composables/useProfile';

const { initialized, initProfile } = useProfile();

onBeforeMount(() => initProfile());
</script>
